import { IAnswerResponse, IAttributionsAnswer, IPreviewResponse, PreviewType } from '../../../api/types';

export const isAnswerPreview = (answer: IAnswerResponse | IAttributionsAnswer): answer is IAnswerResponse => {
    return 'text' in answer;
};

export const isPreviewAvailable = (data: IPreviewResponse | undefined): boolean => {
    return data?.type !== PreviewType.REFERENCE && data?.type !== PreviewType.TABLE;
};
